// 3p
import { connect } from 'react-redux';
import { Link } from 'react-router';
import React from 'react';

// Fp
import { DEFAULT_DRAFT_TITLE } from '../../store/persistence';
import { DRAFT_TITLE_CHANGE, FETCH_DRAFT, EDIT_PAGE, DELETE_PAGE } from '../../constants';
import ActionButton from '../ActionButton';
import BasePage from './BasePage';
import DraftEditor from './DraftEditor';

export class Edit extends React.Component {
  componentWillMount() {
    this.props.fetchDraft(this.props.params.pageId);
  }

  render() {
    const {title, onChange, onSave, onDelete} = this.props;

    const titleInput = (
      <input type="text" placeholder={DEFAULT_DRAFT_TITLE} value={title}
        onChange={(event) => onChange(event.target.value)} />
    );

    const links = [
      <ActionButton>
        <Link to={`/pages/${this.props.params.pageId}`}>Close</Link>
      </ActionButton>,
      <ActionButton onClick={onSave}>Save</ActionButton>,
      <ActionButton onClick={onDelete}>Delete</ActionButton>
    ];

    return (
      <BasePage title={titleInput} links={links}>
        <DraftEditor />
      </BasePage>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.draft.title
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDraft: (pageId) => dispatch({ type: FETCH_DRAFT, pageId }),
    onChange: (title) => dispatch({ type: DRAFT_TITLE_CHANGE, title }),
    onSave: () => dispatch({ type: EDIT_PAGE, pageId: ownProps.params.pageId }),
    onDelete: () => dispatch({ type: DELETE_PAGE, pageId: ownProps.params.pageId })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);



/** WEBPACK FOOTER **
 ** ./src/components/pages/Edit.js
 **/